import api from './api';

export interface LoginData {
  account: string; // 可以是用户名或邮箱
  password: string;
}

export interface AdminLoginData {
  username: string;
  password: string;
}

export interface CreateUserData {
  username: string;
  email: string;
  password?: string;
}

export interface AuthResponse {
  access_token: string;
  user: {
    id: number;
    username: string;
    email: string;
    role: 'user' | 'admin';
  };
}

export const authService = {
  // User login
  login: (data: LoginData) =>
    api.post<AuthResponse>('/auth/user/login', data).then((res) => res.data),

  // Admin login
  adminLogin: (data: AdminLoginData) =>
    api.post<AuthResponse>('/auth/admin/login', data).then((res) => res.data),

  // Admin create user (former register)
  createUser: (data: CreateUserData) =>
    api.post('/admin/register', data).then((res) => res.data),

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Check if user is admin
  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user?.role === 'admin';
  },
};